import { render } from "./start-page.vue?vue&type=template&id=af244c2e&scoped=true&ts=true"
import script from "./start-page.vue?vue&type=script&lang=ts"
export * from "./start-page.vue?vue&type=script&lang=ts"

import "./start-page.vue?vue&type=style&index=0&id=af244c2e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af244c2e"]])

export default __exports__